import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    verifyAuthenticator: (verificationCode) => {
        return (dispatch) => {
            const body = {
                verificationCode
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'two-factor-auth/verify-authenticator',
                    method: 'POST',
                    body: body,
                    types: [
                        types.MFA_VERIFY_AUTHENTICATOR_REQUEST,
                        types.MFA_VERIFY_AUTHENTICATOR_SUCCESS,
                        types.MFA_VERIFY_AUTHENTICATOR_FAILURE
                    ]
                }
            });
        }
    },
    login: (code, userName, password) => {
        return (dispatch) => {
            const body = {
                code,
                userName,
                password
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'two-factor-auth/login',
                    method: 'POST',
                    body: body,
                    types: [
                        types.MFA_LOGIN_REQUEST,
                        types.MFA_LOGIN_SUCCESS,
                        types.MFA_LOGIN_FAILURE
                    ]
                }
            });
        }
    },
    reset: (userName) => {
        return (dispatch) => {
            const body = {
                userName
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'two-factor-auth/reset',
                    method: 'PUT',
                    body: body,
                    types: [
                        types.MFA_RESET_REQUEST,
                        types.MFA_RESET_SUCCESS,
                        types.MFA_RESET_FAILURE
                    ]
                }
            });
        }
    },
    disable: (userName) => {
        return (dispatch) => {
            const body = {
                userName
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'two-factor-auth/disable',
                    method: 'DELETE',
                    body: body,
                    types: [
                        types.MFA_DISABLE_REQUEST,
                        types.MFA_DISABLE_SUCCESS,
                        types.MFA_DISABLE_FAILURE
                    ]
                }
            });
        }
    }
}
